import { jsx } from 'react/jsx-runtime';
import makeBlockie from 'ethereum-blockies-base64';
import 'luxon';
import 'react';
import 'styled-components';
import 'lodash';
import '../icons/ActivityIcon.js';
import '../icons/ArrowDownIcon.js';
import '../icons/ArrowDownRightCircleIcon.js';
import '../icons/ArrowLeftAlignIcon.js';
import '../icons/ArrowLeftIcon.js';
import '../icons/ArrowRightAlignIcon.js';
import '../icons/ArrowRightIcon.js';
import '../icons/ArrowSwitchIcon.js';
import '../icons/ArrowUpIcon.js';
import '../icons/ArrowUpRightCircleIcon.js';
import '../icons/ArrowsAngleExpandIcon.js';
import '../icons/BankIcon.js';
import '../icons/CheckIcon.js';
import '../icons/ChevronDownIcon.js';
import '../icons/ChevronRightIcon.js';
import '../icons/ChevronUpIcon.js';
import '../icons/CopyIcon.js';
import '../icons/CrossIcon.js';
import '../icons/DaiIcon.js';
import '../icons/DangerIcon.js';
import '../icons/DownSortIcon.js';
import '../icons/ExclamationTriangleIcon.js';
import '../icons/ExpandKpiIcon.js';
import '../icons/EyeIcon.js';
import '../icons/EyeSlashIcon.js';
import '../icons/Grid1x2Icon.js';
import '../icons/InfoCircleIcon.js';
import '../icons/ListIcon.js';
import '../icons/LockIcon.js';
import '../icons/MediumIcon.js';
import '../icons/MoonIcon.js';
import '../icons/PiggyBankIcon.js';
import '../icons/QuestionMarkCircleIcon.js';
import '../icons/ShieldIcon.js';
import '../icons/SunIcon.js';
import '../icons/UpSortIcon.js';
import '../icons/XIcon.js';
import '../icons/InfinityIcon.js';
import '../icons/ArrowUpRightBoxIcon.js';
import '../molecules/CurrencyValue/components/Value.js';
import '../../theme/GlobalStyle.js';
import 'react-helmet-async';
import '../../theme/ThemedComponentWrapper.js';
import '../molecules/KpiCard/KpiCard.js';
import '../molecules/PercentageValue.js';
import '../molecules/Tabs/Tabs.js';
import '../molecules/TrendValue.js';
import '../pictograms/EthPictogram.js';
import '../pictograms/EtherScanPictogram.js';
import '../pictograms/DebankPictogram.js';
import '../pictograms/ZapperPictogram.js';
import '../pictograms/DaiPictogram.js';
import '../molecules/Modal/Modal.js';
import '@floating-ui/react';
import '../charts/ChartKpis/ChartKpi.js';
import '../charts/ChartJS.js';
import '../charts/Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../XRay.js';
import Box from './layout/Box/Box.js';
import './layout/Stack/Stack.js';
import './Table/components/Pagination/Pagination.js';
import './Table/Table.js';
import './ToggleSwitch.js';
import './Tooltip/components/TooltipContext.js';

function Blockie({ address, ...rest }) {
    return (jsx(Box, { name: "blockie", as: "img", 
        // @ts-ignore
        src: makeBlockie(address), ...rest }));
}

export { Blockie as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmxvY2tpZS5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvYXRvbXMvQmxvY2tpZS50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IG1ha2VCbG9ja2llIGZyb20gJ2V0aGVyZXVtLWJsb2NraWVzLWJhc2U2NCc7XG5pbXBvcnQgeyBCb3ggfSBmcm9tICdAYXRvbXMnO1xuaW1wb3J0IHsgVGhlbWVkQ29tcG9uZW50V3JhcHBlclByb3BzIH0gZnJvbSAnLi4vLi4vdGhlbWUvVGhlbWVkQ29tcG9uZW50V3JhcHBlcic7XG5cbmV4cG9ydCBpbnRlcmZhY2UgQmxvY2tpZVByb3BzXG4gIGV4dGVuZHMgT21pdDxUaGVtZWRDb21wb25lbnRXcmFwcGVyUHJvcHMsICduYW1lJz4ge1xuICBhZGRyZXNzOiBzdHJpbmc7XG59XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIEJsb2NraWUoeyBhZGRyZXNzLCAuLi5yZXN0IH06IEJsb2NraWVQcm9wcykge1xuICByZXR1cm4gKFxuICAgIDxCb3hcbiAgICAgIG5hbWU9XCJibG9ja2llXCJcbiAgICAgIGFzPVwiaW1nXCJcbiAgICAgIC8vIEB0cy1pZ25vcmVcbiAgICAgIHNyYz17bWFrZUJsb2NraWUoYWRkcmVzcyl9XG4gICAgICB7Li4ucmVzdH1cbiAgICAvPlxuICApO1xufVxuIl0sIm5hbWVzIjpbIl9qc3giXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFTYyxTQUFVLE9BQU8sQ0FBQyxFQUFFLE9BQU8sRUFBRSxHQUFHLElBQUksRUFBZ0IsRUFBQTtJQUNoRSxRQUNFQSxHQUFDLENBQUEsR0FBRyxFQUNGLEVBQUEsSUFBSSxFQUFDLFNBQVMsRUFDZCxFQUFFLEVBQUMsS0FBSzs7UUFFUixHQUFHLEVBQUUsV0FBVyxDQUFDLE9BQU8sQ0FBQyxFQUNyQixHQUFBLElBQUksRUFDUixDQUFBO0FBRU47Ozs7In0=
